// extracted by mini-css-extract-plugin
module.exports = {"root":"SelectSecondary_root__1IhaF","vLegacy":"SelectSecondary_vLegacy__2q08v","error":"SelectSecondary_error__3kc7p","disabled":"SelectSecondary_disabled__1-stN"};